export const DocumentationRequestTypes = Object.freeze({
    "TELEMATIC_COPY":"telematic_copy",
    "ORIGINAL_DUPLICATE":"original_duplicate",
    "ORIGINAL": "original",
    "ENVIRONMENTAL_STICKER":"environmental_sticker",
    "ITV_BOND": "itv_bond",
    "INSURANCE_DUPLICATE":"insurance_duplicate",
    "MAINTENANCE_RECORD": "maintenance_record",
    "PRODUCER_BOOK": "producer_book",
    "ITVM_DUPLICATE": "itvm_duplicate",
    "ZERO_EMISION_CERTIFICATE": "zero_emision_certificate",
    "NO_ACCIDENT_RATE_CERTIFICATE": "no_accident_rate_certificate",
    "RESIDENT_CARD": "resident_card",
    "EUROPEAN_PART": "european_part",
    "FACTORY_PROCESS_INCIDENCE": "factory_process_incidence",
    "FACTORY_PROCESS_TERM": "factory_process_term",
    "INVOICE_DUPLICATE": "invoice_duplicate",
    "FACTORY_PROCESS_NIVE_OR_PC": "factory_process_nive_or_pc",
    "FACTORY_PROCESS_ORIGINAL_DOCUMENTATION_VH": "factory_process_original_documentation_vh",
    "FACTORY_PROCESS_DRIVER_CHANGE": "factory_process_driver_change",
    "CONECTIVITY": "accesory_assembly",
    "INSURANCE_OTHER": "insurance_other",
});

export const DocumentationRequestWithSubtypes = [
    DocumentationRequestTypes.ORIGINAL,
    DocumentationRequestTypes.TELEMATIC_COPY,
    DocumentationRequestTypes.PRODUCER_BOOK,
    DocumentationRequestTypes.NO_ACCIDENT_RATE_CERTIFICATE,
    DocumentationRequestTypes.INVOICE_DUPLICATE,
    DocumentationRequestTypes.ORIGINAL_DUPLICATE
]

export const DocumentationRequestWithLetter = [
    DocumentationRequestTypes.CONECTIVITY,
]

export const factoryProcessVehicleDeliveryTemplateTypes = Object.freeze({
    "FACTORY_PROCESS_INCIDENCE": "factory_process_incidence",
    "FACTORY_PROCESS_TERM": "factory_process_term"
}); 

export const factoryProcessClaimsTemplateTypes = Object.freeze({
    "FACTORY_PROCESS_BODYWORK_CLAIM": "factory_process_bodywork_claim",
    "FACTORY_PROCESS_MAINTENANCE_CLAIM": "factory_process_maintenance_claim",
    "FACTORY_PROCESS_TYRES_CLAIM": "factory_process_tyres_claim",
    "FACTORY_PROCESS_URGENT_CLAIM": "factory_process_urgent_claim"
});


export const TerminationsTemplateTypes = Object.freeze({
    "RENTING_OWN_INSURANCE": "renting_own_insurance",
    "VALUATION": "valuation",
    "RENTING_OTHER_INSURANCE": "renting_other_insurance",
    "TRADITIONAL_RENTING":"traditional_renting",
    "AAPP":"aapp"
})


export const InformationTemplateTypes = Object.freeze({
    "ACCESSORIES": "accessories",
    "RADIO_CODE": "radio_code",
    "AVAILABLE_TYRES": "available_tyres"
})


export const SubstitutionVehicleTemplateTypes = Object.freeze({
    "SUBSITUTION_VEHICLE_RETURN": "subsitution_vehicle_return",
    "SUBSITUTION_VEHICLE": "subsitution_vehicle",
    "SUBSITUTION_VEHICLE_OTHER": "subsitution_vehicle_other"
})